import { keys } from 'ramda';
import { mainSchedulerConfigSchema } from 'schemas/app-config';
import type { BookingParamsSchema, MainAppOptions, MainAppOptionsBase } from 'types';
import { getLastBookedAppointmentFromStorage } from 'utils/appointment';
import { getBookingParamsFromUrl, pendingBookingParamsToSync } from 'utils/url';

/**
 * This function throws an error if renderOptions is not according to the schema
 * @throws YupValidationError
 */
const getMainAppOptions = (renderOptions: MainAppOptionsBase): MainAppOptions => {
    const bookingUrlParams = getBookingParamsFromUrl();
    const lastBookedAppointment = getLastBookedAppointmentFromStorage();
    // `validateSync` throws an error if the object is not according to the schema
    const validatedOptions = mainSchedulerConfigSchema.validateSync(renderOptions, { stripUnknown: false });

    const bookingParams: Partial<BookingParamsSchema> = { ...lastBookedAppointment, ...bookingUrlParams };

    // Add all booking params to sync with the booking state
    keys(bookingParams).forEach((key) => {
        pendingBookingParamsToSync.add(key);
    });

    return { ...validatedOptions, ...bookingParams, type: 'main' };
};

export { getMainAppOptions };
